export type StockBarcodePrintDecision =
  | { ok: true; productId: string; printerName: string }
  | { ok: false; reason: 'cancelled' | 'missing_binding' | 'missing_code' };

/**
 * Gate for Consultation Stock barcode print (US-INV-05).
 * Confirm must be true. Bound printer and product code are required.
 */
export function decideStockBarcodePrint(input: {
  confirmed: boolean;
  productId: string;
  barcode?: string | null;
  sku?: string | null;
  barcodePrinterName?: string | null;
}): StockBarcodePrintDecision {
  if (!input.confirmed) {
    return { ok: false, reason: 'cancelled' };
  }
  const code = (input.barcode || input.sku || '').trim();
  if (!code) {
    return { ok: false, reason: 'missing_code' };
  }
  const printerName = input.barcodePrinterName?.trim() || '';
  if (!printerName) {
    return { ok: false, reason: 'missing_binding' };
  }
  return {
    ok: true,
    productId: input.productId,
    printerName,
  };
}
